
import '../App.css';


function Navs() {
  return (
    <div>
    </div>
  );
}

export default Navs;